package top.wcpe.allincore.dsl.ir.model

/**
 * PAPI 占位符 IR 块（编译期 papi {} 块的产物）。
 *
 * 运行时已全链路消费：服务端 screen 经 UiService、HUD 经 HudService 各自的
 * PlaceholderTickerHub 按 token 注册并周期解析下发；客户端 ClientPlaceholderStore
 * 按 token 收包后跑 pipe 并写入 bindState。screen 与 HUD 两路对称、token 池互斥。
 */
class UiPlaceholderBlock(
    shortName: String?,
    val refreshMs: Long,
    val bindState: String?,
    pipeExprBytes: ByteArray?,
    val onChange: String?,
    val available: Boolean,
) {
    val shortName: String = shortName ?: throw NullPointerException("shortName")

    // 防御式拷贝：允许 null（无 pipe）。
    private val pipeExprBytesInternal: ByteArray? = pipeExprBytes?.copyOf()

    constructor(
        shortName: String?,
        refreshMs: Long,
        bindState: String?,
        pipeExprBytes: ByteArray?,
        onChange: String?,
    ) : this(shortName, refreshMs, bindState, pipeExprBytes, onChange, true)

    /** 复刻原 Java `getPipeExprBytes()`：暴露为属性 `pipeExprBytes`，保留 private backing + 防御拷贝。 */
    val pipeExprBytes: ByteArray?
        get() = pipeExprBytesInternal?.copyOf()

    /** 复刻原 Java `isAvailable()`：改为计算属性以保下游属性语法访问。 */
    val isAvailable: Boolean
        get() = available

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiPlaceholderBlock) return false
        return refreshMs == other.refreshMs &&
            available == other.available &&
            shortName == other.shortName &&
            bindState == other.bindState &&
            pipeExprBytesInternal.contentEquals(other.pipeExprBytesInternal) &&
            onChange == other.onChange
    }

    override fun hashCode(): Int {
        // 复刻 Objects.hash(shortName, refreshMs, bindState, onChange, available) 再 31*result + Arrays.hashCode(pipe)。
        var result = 1
        result = 31 * result + shortName.hashCode()
        result = 31 * result + refreshMs.hashCode()
        result = 31 * result + (bindState?.hashCode() ?: 0)
        result = 31 * result + (onChange?.hashCode() ?: 0)
        result = 31 * result + available.hashCode()
        result = 31 * result + pipeExprBytesInternal.contentHashCode()
        return result
    }

    override fun toString(): String =
        "UiPlaceholderBlock{" + shortName +
            ",refreshMs=" + refreshMs +
            ",bindState=" + bindState +
            ",pipe=" + (pipeExprBytesInternal?.size ?: 0) +
            ",onChange=" + onChange +
            ",available=" + available + "}"
}
